import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'app-ai-blueprint-skeleton',
  standalone: true,
  imports: [CommonModule, SkeletonComponent],
  templateUrl: './ai-blueprint-skeleton.component.html'
})
export class AiBlueprintSkeletonComponent {
  @Input() count: number = 6;
  @Input() showHeader: boolean = true;

  get placeholders(): number[] {
    return Array.from({ length: this.count }, (_, i) => i);
  }
}
